import Flickity from 'flickity';

class Tier1ProductGallery {
	$galleryModal: HTMLElement | null = null;
	$thumbs!: NodeListOf<Element>;
	$close: Element | null = null;
	$rotator: HTMLElement | null = null;
	flkty: Flickity | null = null;

	init() {
		this.cache();
		if (this.$galleryModal && this.$rotator) {
			this.events();
			this.initModalRotator();
		}
	}

	cache() {
		this.$galleryModal = document.querySelector('.galleryModal');
		this.$thumbs = document.querySelectorAll('.tier1ProductGallery .js-thumb');
		this.$close = document.querySelector('.galleryModal .js-close');
		this.$rotator = document.querySelector('.galleryModal .rotator');
	}

	events() {
		for (let j = 0; j < this.$thumbs.length; j++) {
			this.$thumbs[j].addEventListener('click', this.thumbClick.bind(this));
		}

		document.addEventListener('keydown', this.keypress.bind(this));

		if (this.$close) {
			this.$close.addEventListener('click', this.closeClick.bind(this));
		}
	}

	keypress(e: KeyboardEvent) {
		if (e.keyCode === 27) {
			this.closeGallery();
		}
	}

	initModalRotator() {
		this.flkty = new Flickity(this.$rotator!, {
			wrapAround: false,
			pageDots: true,
			prevNextButtons: true,
			cellAlign: 'center',
			contain: true,
		});
	}

	thumbClick(e: Event) {
		e.preventDefault();
		const target = e.currentTarget as HTMLElement;
		const index = target.getAttribute('data-index');
		if (index !== null) {
			this.openGallery(Number(index) - 1);
		}
	}

	closeClick(e: Event) {
		e.preventDefault();
		this.closeGallery();
	}

	openGallery(slide: number) {
		this.flkty?.select(slide);
		document.body.classList.add('scroll-disabled');
		this.$galleryModal!.classList.add('active');
	}

	closeGallery() {
		document.body.classList.remove('scroll-disabled');
		this.$galleryModal!.classList.remove('active');
	}
}

new Tier1ProductGallery().init();
